import React from 'react'
import { Typography } from '@chilecompra/react-kit/components'
import { Banner, BannerBlock, BannerTitle } from './HomeForm.styles'

/**
 * The BannerSection's component.
 */
const BannerSection = () => {
  return (
    <Banner>
      <BannerBlock>
        <BannerTitle>Convenio Marco de pasajes aéreos</BannerTitle>
        <Typography color="white" sx={{ maxWidth: 300 }} variant="body1">
          En este Convenio Marco podrás comprar pasajes aéreos nacionales hasta 1.000 UTM para los pasajeros que
          registres.
        </Typography>
      </BannerBlock>
    </Banner>
  )
}

export default BannerSection
